import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleBtn", "copyBtn"]
  static values = { json: String }

  connect() {
    this.expanded = true
    this.fullText = this.contentTarget.textContent
    const lines = this.fullText.split("\n")
    if (lines.length > 6) {
      this.collapsedText = lines.slice(0, 3).join("\n") + "\n... (" + (lines.length - 3) + " more lines)"
    } else {
      this.collapsedText = this.fullText
      this.toggleBtnTarget.style.display = "none"
    }
  }

  toggle() {
    this.expanded = !this.expanded
    if (this.expanded) {
      this.contentTarget.textContent = this.fullText
      this.toggleBtnTarget.textContent = "Collapse"
    } else {
      this.contentTarget.textContent = this.collapsedText
      this.toggleBtnTarget.textContent = "Expand"
    }
  }

  copy() {
    const text = this.jsonValue || this.fullText
    navigator.clipboard.writeText(text).then(() => {
      const original = this.copyBtnTarget.textContent
      this.copyBtnTarget.textContent = "Copied!"
      setTimeout(() => {
        this.copyBtnTarget.textContent = original
      }, 2000)
    })
  }
}
